import classnames from 'classnames';
import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import style from './index.module.css';

export type NavigationItem = {
  displayName: string;
  slug: string;
};

interface Props {
  items: NavigationItem[];
}

export function NavigationMenu({ items }: Props) {
  const { hash } = useLocation();

  const isActive = useCallback(
    (itemSlug: string): boolean => {
      return hash === `#${itemSlug}`;
    },
    [hash],
  );

  useEffect(() => {
    if (items)
      setTimeout(() => {
        document.getElementById(globalThis.location.hash.replace('#', ''))?.scrollIntoView({ behavior: 'auto' });
      }, 500);
  }, [items]);

  return (
    <ul className={style['MenuItems']}>
      {items.map((item) => {
        return (
          <li key={item.slug}>
            <a
              className={classnames({
                [style['MenuItem']!]: true,
                [style['Active']!]: isActive(item.slug),
              })}
              href={`#${item.slug}`}
            >
              {item.displayName}
            </a>
          </li>
        );
      })}
    </ul>
  );
}
